import { useEffect, useState } from "react";

// True on mobile viewports (<768px) OR when running as an installed PWA (standalone display mode).
export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return false;
    const isNarrow = window.matchMedia("(max-width: 767px)").matches;
    const isStandalone =
      window.matchMedia?.("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;
    return isNarrow || isStandalone;
  });

  useEffect(() => {
    const mqNarrow = window.matchMedia("(max-width: 767px)");
    const mqStandalone = window.matchMedia("(display-mode: standalone)");
    const update = () => {
      setIsMobile(
        mqNarrow.matches ||
          mqStandalone.matches ||
          window.navigator.standalone === true
      );
    };
    mqNarrow.addEventListener("change", update);
    mqStandalone.addEventListener?.("change", update);
    return () => {
      mqNarrow.removeEventListener("change", update);
      mqStandalone.removeEventListener?.("change", update);
    };
  }, []);

  return isMobile;
}
